import { getBorderRadius } from '@/lib/util';
import { ElementProps } from '@/types/elements';
import { ArrowUpRight } from 'react-feather';


export default function ButtonElement({ block: { id: blockId, data }, viewMode, tracer, appearance }: ElementProps) {
    let { title, link, type, prefix } = data;
    if (!link.startsWith('http')) {
        link = `${prefix}${link}`
    }
    const onClick = () => tracer?.openLink({ blockId, link, meta: {} })
    
    return (
        <div className="w-full transition duration-500 hover:scale-105">
            <button onClick={onClick}
                className="inline-flex justify-between w-full px-4 py-3 duration-1000 ease-in-out transform border shadow group button-link">
                <div>
                    {type && type !== 'custom' && <span className="hidden pl-3 text-xl">
                        <img height="22" width="22" src={`https://unpkg.com/simple-icons@v4/icons/${type}.svg`} alt={type} />
                    </span>}
                    <span className={`text-sm ${type && type !== 'custom' ? 'pl-1' : ''}`}>{title}</span>
                </div>
                <ArrowUpRight className="transition stroke-[1.5] arrow-icon duration-400 group-hover:rotate-45" height={24} width={24} />
            </button>

            <style jsx>{`
                .button-link {
                    color: ${appearance?.buttonTextColor};
                    border-radius: ${getBorderRadius(appearance!)};
                    background-color: ${appearance?.buttonBackgroundColor};
                    border-color: ${appearance?.buttonBackgroundColor};
                }
                .button-link:hover {
                    color: ${appearance?.buttonBackgroundColor};
                    background-color: white;
                }
          `}</style>
        </div>
    )
}
